import { connect } from 'react-redux';
import { isConnected, isConnecting, getAddress, getChainId, getAppChainId, getManaBalances, isSwitchingNetwork } from '../../modules/wallet/selectors';
import { getData as getProfiles } from '../../modules/profile/selectors';
import { getError as getWalletError } from '../../modules/wallet/selectors';
import { getLocale } from '../../modules/translation/selectors';
import { disconnectWallet, switchNetworkRequest } from '../../modules/wallet/actions';
import Navbar from './Navbar';
const mapState = (state) => {
    const address = getAddress(state);
    const profile = address ? getProfiles(state)[address] : undefined;
    return {
        avatar: profile ? profile.avatars[0] : undefined,
        chainId: getChainId(state),
        manaBalances: getManaBalances(state),
        address: getAddress(state),
        locale: getLocale(state),
        isSignedIn: isConnected(state),
        isSigningIn: isConnecting(state),
        appChainId: getAppChainId(state),
        isSwitchingNetwork: isSwitchingNetwork(state),
        walletError: getWalletError(state)
    };
};
const mapDispatch = (dispatch) => ({
    onSwitchNetwork: (chainId, fromChainId) => dispatch(switchNetworkRequest(chainId, fromChainId)),
    onSignOut: () => dispatch(disconnectWallet())
});
const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps
});
export default connect(mapState, mapDispatch, mergeProps)(Navbar);
//# sourceMappingURL=Navbar.container.js.map